<app-select-dropdown class="app-slect" (onSelect)="onSelectItem($event)">
  <ng-container *ngFor="let item of optionsList;let i=index">
    <option class="option" [attr.selected]="i==selectedIndex" value="{{item.value}}">
      {{item.name}}
    </option>
  </ng-container>
  </app-select-dropdown>
